export default __webpack_public_path__ + "static/media/winner_9.c5e7eb13.jpg";